.container
    width: 100%
    label
        margin-right: 10px